// 简单的哈希算法：为任意字符串生成一个 32 位整数。
// 原理：http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
export function stringHash(str) {
    var hash = 0;
    var data = String(str);
    if (data.length === 0)
        return hash;
    for (var i = 0; i < data.length;) {
        var char = data.charCodeAt(i);
        hash = (hash << 5) - hash + char; // eslint-disable-line no-bitwise
        hash &= hash; // eslint-disable-line no-bitwise
        i += 1;
    }
    return hash;
}
/**
 * 将字符串转化成小写
 * @param char
 * @returns
 */
export function lower(char) {
    return (char || '').toLowerCase();
}
